"use client"

import { useEffect, useState } from "react"

export default function IframeComponent({ html }: { html: string }) {
  const [_, width, height] = /width="([^"]*)" height="([^"]*)"/.exec(html) || []

  const ratio =
    height && width
      ? ((Number(height) / Number(width)) * 100).toPrecision(4) + "%"
      : null

  const src = html.match(/src="([^"]*)"/)?.[1]

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return (
    <div
      className="responsive-object my-5"
      style={{ paddingBottom: ratio || 0 }}
    >
      <iframe
        suppressHydrationWarning
        src={src}
        allowFullScreen={true}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      ></iframe>
    </div>
  )
}
